export default {"src":"/_next/static/media/BSC.eb26b6d5.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};